import { render } from "./footerSlot.vue?vue&type=template&id=9b1de240"
import script from "./footerSlot.vue?vue&type=script&lang=js"
export * from "./footerSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__